import { FilterOutlined } from '@ant-design/icons';
import { Button, Popconfirm, Badge, Popover } from 'antd';

const PopconfirmFilter = ({ description, title, icon, appliedFiltersCount }) => {
    return (
        <Popover placement="rightBottom" title={title || null} content={description || <></>} icon={icon || null}>
            <Badge count={appliedFiltersCount} size="small">
                <Button type="primary" size="small">
                    <FilterOutlined />
                </Button>
            </Badge>
        </Popover>
    );
};

export default PopconfirmFilter;
